import React, { Component } from 'react';
import _ from 'lodash';
import {
  Table,
} from 'antd';
import 'antd/dist/antd.css';
import i18n from '../../config/i18n';

class QuestionView extends Component {
  constructor(props) {
    super(props);

    const {
      item: { question: { questionType } },
      savedAnswers,
      index,
      disableInput,
    } = this.props;
    let selectionType = null;

    switch (questionType) {
      case 'multipleChoice':
        selectionType = 'radio';
        break;
      case 'multipleAnswer':
        selectionType = 'checkbox';
        break;
      default: break;
    }

    this.state = {
      multipleChoiceTable: {
        bordered: true,

        // You can hide the "check all" checkbox by css.
        // https://github.com/ant-design/ant-design/issues/8766
        rowSelection: {
          type: selectionType,
          selectedRowKeys: savedAnswers[index] ? savedAnswers[index].selectedRows : [],
          onSelect: (record) => {
            this.handleRowSelection(record, record.key);
          },
          getCheckboxProps: (record) => {
            const options = { disabled: disableInput };
            if (record.renderAnswerType === 'empty') { options.style = { display: 'none' }; }
            return options;
          },
        },
        size: 'middle',
        pagination: false,
      },
    };
  }

  getGroupAParams = () => {
    const {
      item: {
        question: {
          mainText,
          secondaryText,
          questionType,
        },
        answers,
      },
      index,
    } = this.props;

    // main (group A) questions
    const groupAParams = {};
    groupAParams.questionTitle = [
      {
        title: mainText,
        dataIndex: 'subtitle',
        render: value => ({
          children: value,
          props: { rowSpan: value ? 1 : 0 },
        }),
      },
    ];
    groupAParams.questionSubtitle = [
      {
        key: index,
        subtitle: secondaryText,
        rowSpan: 0,
      },
    ];
    groupAParams.answerColumns = [
      {
        title: 'Option',
        dataIndex: 'answerText',
        render: (value, record) => (record.renderAnswerType === 'empty' ? null : value),
      },
      {
        title: 'Score',
        width: 100,
        dataIndex: 'score',
        render: (value, record) => (record.renderAnswerType === 'empty' ? null : value),
      },
    ];
    groupAParams.offeredAnswers = answers.map((el, i) => ({
      key: i,
      answerId: el.id,
      answerText: el.mainText,
      renderAnswerType: el.renderAnswerType,
      score: el.score,
      selectionRule: el.selectionRule,
    }));

    groupAParams.questionType = questionType;
    groupAParams.tableStyle = answers.reduce((prev, current) => prev || (current.renderAnswerType === 'newLines'), false)
      ? { whiteSpace: 'pre' }
      : null;
    return groupAParams;
  }

  getGroupBParams = () => {
    const {
      item: {
        question: {
          mainText,
          secondaryText,
          questionType,
        },
        answers,
      },
      index,
    } = this.props;

    // Additional Questions (group B) questions
    const groupBParams = {};
    groupBParams.questionTitle = [
      {
        title: mainText,
        dataIndex: 'subtitle',
        render: value => ({
          children: value,
          props: { rowSpan: value ? 1 : 0 },
        }),
      },
    ];
    groupBParams.questionSubtitle = [
      {
        key: index,
        subtitle: secondaryText,
        rowSpan: 0,
      },
    ];
    groupBParams.answerColumns = [
      {
        title: 'Option',
        dataIndex: 'answerText',
        render: (value, record) => (record.renderAnswerType === 'empty' ? null : value),
      },
    ];
    groupBParams.offeredAnswers = answers.map((el, i) => ({
      key: i,
      answerId: el.id,
      answerText: el.mainText,
      renderAnswerType: el.renderAnswerType,
      selectionRule: el.selectionRule,
    }));

    groupBParams.questionType = questionType;
    groupBParams.tableStyle = answers.reduce((prev, current) => prev || (current.renderAnswerType === 'newLines'), false)
      ? { whiteSpace: 'pre' }
      : null;
    return groupBParams;
  }

  getParams = () => {
    const {
      item: {
        question,
      },
    } = this.props;

    switch (question.questionType) {
      case 'multipleAnswer':
      case 'multipleChoice':
        switch (question.questionGroup) {
          case 'A':
            return this.getGroupAParams();
          case 'B':
            return this.getGroupBParams();
          default: return null;
        }
      default: return null;
    }
  }

  getElement = () => {
    const {
      questionTitle,
      questionSubtitle,
      answerColumns,
      offeredAnswers,
      questionType,
      tableStyle,
    } = this.getParams();

    const {
      showAlert,
    } = this.props;
    const {
      multipleChoiceTable: {
        rowSelection,
      },
    } = this.state;
    let selectionType = null;

    switch (questionType) {
      case 'multipleChoice':
        selectionType = 'radio';
        break;
      case 'multipleAnswer':
        selectionType = 'checkbox';
        break;
      default: break;
    }

    const newRowSelection = {
      ...rowSelection,
      type: selectionType,
    };

    return (
      <div>
        <br />
        <Table
          bordered
          columns={questionTitle}
          dataSource={questionSubtitle}
          size="middle"
          pagination={false}
        />
        <Table
          {...this.state.multipleChoiceTable} // sm change
          rowSelection={newRowSelection}
          onRow={this.handleMultipleChoiceTableOnRow} // sm change
          columns={answerColumns}
          dataSource={offeredAnswers}
          style={tableStyle}
        />
        {
          showAlert && (
            <p style={{ color: 'red' }}>
              {i18n.t('fppQuestionAlert')}
            </p>
          )
        }
      </div>
    );
  }

  saveAnswer = (questionType, answer) => {
    const {
      save,
      index,
    } = this.props;
    save(questionType, answer, index);
  }

  containsAnswerWithId = (selectedRowKeys, offeredAnswers, id) =>
    !_.isEmpty(selectedRowKeys.filter(key => offeredAnswers[key].answerId === id))

  generateNewSelectedRowKeys = (
    currentSelectedRowKeys,
    offeredAnswers, targetIndex,
    questionType) => {
    const {
      selectionRule: {
        dependency,
        answerGroups,
      },
    } = offeredAnswers[targetIndex];

    /**
     * Apply dependency rule:
     * We use Disjunctive Normal Form to represent our dependency logic:
     * First level of the array applies OR operation,
     * and the second level of the array applies AND operation.
     */
    const canBeSelected = _.isEmpty(dependency)
      ? true
      : dependency.reduce((orResult, answerId) => {
        if (Array.isArray(answerId)) {
          return orResult || answerId.reduce((andResult, id) => andResult
            && this.containsAnswerWithId(currentSelectedRowKeys, offeredAnswers, id), true);
        }
        return orResult
          || this.containsAnswerWithId(currentSelectedRowKeys, offeredAnswers, answerId);
      }, false);

    if (!canBeSelected) return currentSelectedRowKeys;

    /**
     * Apply answerGroup rule
     */
    // Clear selected answers in different answer groups
    const newSelectedRowKeys = currentSelectedRowKeys.filter(key =>
      _.intersection(answerGroups,
        offeredAnswers[key].selectionRule.answerGroups).length > 0);

    // If the row is already selected in multipleAnswer type question, remove it.
    const rowKeyIndex = newSelectedRowKeys.indexOf(targetIndex);
    if (rowKeyIndex !== -1) {
      if (questionType === 'multipleAnswer') newSelectedRowKeys.splice(rowKeyIndex, 1);
    } else {
      newSelectedRowKeys.push(targetIndex);
    }
    return newSelectedRowKeys;
  }

  handleRowSelection = (record, rowIndex) => {
    // Ignore empty select events.
    if (record.renderAnswerType === 'empty') return;

    let newSelectedRowKeys = [];
    const {
      item: { question: { questionType } },
      disableInput,
    } = this.props;
    const {
      multipleChoiceTable: { rowSelection: { selectedRowKeys } },
      multipleChoiceTable: { rowSelection },
      multipleChoiceTable,
    } = this.state;
    const { offeredAnswers } = this.getParams();

    if (selectedRowKeys) {
      newSelectedRowKeys = this.generateNewSelectedRowKeys(
        selectedRowKeys,
        offeredAnswers,
        rowIndex,
        questionType,
      );
    }

    if (!disableInput) {
      this.setState({
        multipleChoiceTable: {
          ...multipleChoiceTable,
          rowSelection: { ...rowSelection, selectedRowKeys: newSelectedRowKeys }, // sm change
        },
      }, () => this.saveAnswer(questionType, newSelectedRowKeys, record));
    }
  }

  handleMultipleChoiceTableOnRow = (record, rowIndex) => ({
    onClick: () => {
      this.handleRowSelection(record, rowIndex);
    },
  });

  render() {
    return this.getElement();
  }
}

export default QuestionView;



// WEBPACK FOOTER //
// ./src/components/fpp/QuestionView.js